import { TOP_COUNTRY_CODES } from '@/enums/topCountries';
export default {
    data() {
        return {
            phoneCountry: null,
            isPhoneInputInitialized: false,
            isChangingCountryFromPicker: false,
        };
    },
    mounted() {
        setTimeout(() => { this.isPhoneInputInitialized = true; }, 1);
    },
    methods: {
        emitChange() {},
        isPhoneInputValid(val) {
            return this.isPhoneInputInitialized && !this.isChangingCountryFromPicker && val && val.startsWith('+');
        },
        onPhoneInput(val) {
            this.emitChange();
            if (!this.isPhoneInputValid(val)) return;
            this.syncCountryFromDialCode(val);
        },
        onPhoneInputByRef(val, ref) {
            this.emitChange();
            if (!this.isPhoneInputValid(val)) return;

            const matchedCountry = this.findBestCountryByDialCode(val);
            if (!matchedCountry) return;

            this.$refs[ref].$refs.telInput.choose(matchedCountry.code2);
            this.emitChange();
        },
        syncCountryFromDialCode(phone) {
            const matchedCountry = this.findBestCountryByDialCode(phone);
            if (!matchedCountry) return;
            if (this.selectedCountry && this.selectedCountry.id === matchedCountry.id) return;

            this.selectedCountry = matchedCountry;
            this.$refs.phoneInput.$refs.telInput.choose(matchedCountry.code2);
            this.emitChange();
            this.applyCountryInfo && this.applyCountryInfo(matchedCountry);
        },
        findBestCountryByDialCode(phone) {
            const dialPart = phone.slice(1);
            let bestMatch = null;
            let bestMatchLength = 0;

            for (const country of this.getCountries) {
                const dial = country.dial;
                if (!dial || !dialPart.startsWith(dial)) continue;

                const isLonger = dial.length > bestMatchLength;
                const isSameLengthButPreferred = dial.length === bestMatchLength
                    && TOP_COUNTRY_CODES.includes(country.code2)
                    && (!bestMatch || !TOP_COUNTRY_CODES.includes(bestMatch.code2));

                if (isLonger || isSameLengthButPreferred) {
                    bestMatch = country;
                    bestMatchLength = dial.length;
                }
            }

            return bestMatch;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/phoneCountrySync.js